/** @format */

export const sortByLocalizedValueFilterModule = 'sis-components.string.sortByLocalizedValueFilter';

(function () {
    sortByLocalizedValue.$inject = ['localeService'];
    angular
        .module(sortByLocalizedValueFilterModule, ['sis-common.l10n.localeService'])
        .filter('sortByLocalizedValue', sortByLocalizedValue);

    function sortByLocalizedValue(localeService) {
        /**
         * Sort by localized value
         * example usage: ng-repeat="cur in curs |sortByLocalizedValue:'name'"
         *
         * @param array
         * @param key|string
         * @param reverse|boolean
         */
        return function (objectList, key, reverse) {
            var sorted = _.sortBy(objectList, function (obj) {
                return localeService.getLocalizedValue(_.result(obj, key));
            });
            if (reverse) {
                sorted.reverse();
            }
            return sorted;
        };
    }
})();
